var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBank(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 399.82 268.43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u8CC7\u7522 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u5716\\u5C64_2",
    "data-name": "\\u5716\\u5C64 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u5716\\u5C64_1-2",
    "data-name": "\\u5716\\u5C64 1"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 392.01,
    cy: 112.34,
    rx: 7.81,
    ry: 9.94
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.47,3A7.11,7.11,0,0,0,392,0H7.81C3.66,0,0,4.46,0,9.94V258.48c0,5.42,3.55,9.95,7.81,9.95H392c4.26,0,7.81-4.53,7.81-9.95V157.08c0-5.49-3.51-9.94-7.81-9.94s-7.81,4.45-7.81,9.94v91.46H15.62V19.88H384.2V67.6c0,5.48,3.51,9.94,7.81,9.94s7.81-4.46,7.81-9.94V9.94A11.33,11.33,0,0,0,397.47,3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.08,104.39H39c-4.31,0-7.8,4.45-7.8,9.94s3.49,9.94,7.8,9.94h203c4.31,0,7.81-4.45,7.81-9.94S246.39,104.39,242.08,104.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.65,144.15H39c-4.31,0-7.8,4.46-7.8,9.95S34.73,164,39,164H218.65c4.31,0,7.81-4.45,7.81-9.94S223,144.15,218.65,144.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39,64.62H85.9c4.31,0,7.81-4.45,7.81-9.94s-3.5-9.94-7.81-9.94H39c-4.31,0-7.8,4.45-7.8,9.94S34.73,64.62,39,64.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.73,104.39h23.42c4.32,0,7.81-4.45,7.81-9.94s-3.49-10-7.81-10H333.44V74.56c0-5.49-3.5-9.94-7.81-9.94s-7.81,4.45-7.81,9.94V84.93c-11.06,2.37-19.52,14.65-19.52,29.4,0,16.45,10.51,29.82,23.43,29.82h7.81c4.3,0,7.8,4.47,7.8,9.95s-3.5,9.94-7.8,9.94H306.11c-4.31,0-7.81,4.45-7.81,9.94s3.5,9.94,7.81,9.94h11.71v10c0,5.49,3.5,9.94,7.81,9.94s7.81-4.45,7.81-9.94V183.5C344.5,181.13,353,168.85,353,154.1c0-16.45-10.51-29.83-23.43-29.83h-7.8c-4.31,0-7.81-4.46-7.81-9.94S317.42,104.39,321.73,104.39Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBank);
export default __webpack_public_path__ + "static/media/bank.41ba5c7ecd25d0ddcb6e3294bd2d1f91.svg";
export { ForwardRef as ReactComponent };